




















































































































































































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {SegmentRule} from "@/modules/Segmentation/models/SegmentRule";
import {AntiSegmentRule} from "@/modules/Segmentation/models/AntiSegmentRule";
import {ISegmentationFormStoreService} from "@/modules/Segmentation/services/ISegmentationFormStoreService";
import {container} from "@/services/registerServiceProvider";
import RangeIntFormSwitchable from "@/components/RangeIntFormSwitchable.vue";
import StringArrayFormInvertible from "@/components/StringArrayFormInvertible.vue";
import SwitchFormSwitchable from "@/components/SwitchFormSwitchable.vue";
import RangeSelectIntFormSwitchable from "@/components/RangeSelectIntFormSwitchable.vue";
import AddressSearchForm from "@/components/AddressSearchForm.vue";
import AddressSearchFormInvertible from "@/components/AddressSearchFormInvertible.vue";
import { Address } from "@/models/Address";
import { IAddressService } from "@/modules/Segmentation/services/IAddressService";

    @Component({
        components: {
            AddressSearchFormInvertible,
            AddressSearchForm,
            RangeSelectIntFormSwitchable,
            SwitchFormSwitchable,
            StringArrayFormInvertible,
            RangeIntFormSwitchable,
            SegmentRuleCommissionCmpt: () => import("@/components/SegmentRuleCommissionInfo/SegmentRuleCommissionCmpt.vue"),
        }
    })
    export default class SegmentationRuleForm extends Vue {
        @Prop() public readonly value!: SegmentRule | AntiSegmentRule;
        @Prop() public readonly loading!: boolean;
        @Prop({default: true}) public readonly isAllowedToEditMasterRule!: boolean;

        private readonly addressService: IAddressService = container.resolve("IAddressService");
        private readonly formStoreService: ISegmentationFormStoreService = container
            .resolve("ISegmentationFormStoreService");

        ruleAddresses: Address[] = [];
        knownAddesses: Map<string, Address> = new Map();

        get ruleForVin(): Function {
          return (values: string[]): any => {
            const regex: RegExp = /^[a-zA-Z0-9]+$/;
            let errorMsg: string = "";

            values.forEach((item) => {
              if (!regex.test(item)) {
                values.splice(-1, 1);
                errorMsg = "Некорректный VIN. Допустимы символы латинского алфавита (A-Z) и цифры. Общее количество 17 символов";
              }
            });

            return errorMsg || true;
          }
        }

        isRuleAntiSegment(obj: SegmentRule | AntiSegmentRule): obj is AntiSegmentRule {
            return obj instanceof AntiSegmentRule;
        }

        created(): void {
            Promise.all([
                this.formStoreService.fillCarModels(),
                this.formStoreService.fillCarPurposes(),
                this.formStoreService.fillCarTypes(),
            ]);
        }

        setIsUseSupplementaryRule(val: string) {
          switch (val) {
            case "true":
              this.value.isUseSupplementary.boolean = true;
              break;
            case "false":
              this.value.isUseSupplementary.boolean = false;
              break;
            case "null":
            default:
              this.value.isUseSupplementary.boolean = null;
              break;
          }
        }

        @Watch('value.isMasterRule.boolean')
        disableForbidRule(): void {
          if (this.value.isMasterRule.boolean) {
            this.value.isForbidRule.boolean = false;
          }
        }

        @Watch("value.title", { immediate: true })
        loadAddressesFromRule(): void {
          let kladrs = this.value.clientAddressCode.whiteList
          let unknownKladrs: string[] = []

          this.ruleAddresses = [];

          if (this.knownAddesses.size === 0 && kladrs !== null ) {
            unknownKladrs = kladrs;
            kladrs = null;
          }

          kladrs?.forEach(code => {
            const address = this.knownAddesses.get(code)

            if (address) {
              this.ruleAddresses.push(address)
            } else {
              unknownKladrs.push(code)
            }
          })

          this.addressService.getAddressesFromKladrs(unknownKladrs).then(addresses => {
              this.ruleAddresses = this.ruleAddresses.concat(addresses)
          })
        }

        setAndSendAddresses(addresses: Address[]) {
          this.value.clientAddressCode.whiteList = addresses.map(address => address.kladr);
          this.ruleAddresses = addresses;
          const addressesFromDaData = addresses.filter(address => !this.knownAddesses.has(address.kladr));
          this.sendAddressesToServer(addressesFromDaData);
          addressesFromDaData.forEach(address => {
            this.knownAddesses.set(address.kladr, address);
          })
        }

        sendAddressesToServer(addresses: Address[]) {
          if (addresses.length === 0) {
            return;
          }

          this.addressService.addKladrs(addresses); // async
        }
      }
